// extracted by mini-css-extract-plugin
export var aiStarIcon = "_7z-4";
export var closeButton = "_7z-6";
export var dismissButton = "_7z-3";
export var editImageWithAiContainer = "_7z-8";
export var imageUploadWrapper = "_7z-7";
export var misspelledWord = "_7z-5";
export var spellCheckContainer = "_7z-2";
export var spin = "_7z-1";
export var spinning = "_7z-0";